//= Functions & Modules
// Own
import { getDialogsSystem } from '../../dialogs';

export function showNoConnectionDialog() {
    getDialogsSystem().showDialog(() => import('../components/NoConnectionDialog'));
}
